/* ===== Christmas World Collection Content JS ===== */
/* Handles: FAQ accordion, comparison table Yes/No icons, section wrapping */
/* Owner: Lyra (SEO/content agent). Elara: do NOT edit this file. */
/* v1.4 — Added .cw-article-body as a findRte() target so the FAQ        */
/*        accordion, Quick Tips / Steps boxes, Complete the Look pills   */
/*        and comparison-table icons also activate on blog article       */
/*        pages (Elara's cw-article-guides.liquid template), not just     */
/*        collection pages. Paired with cw-collection-content.css v3.6.   */
/* v1.3 — FIXED race condition that caused the FAQ accordion (and Quick   */
/*        Tips / Steps / Safety boxes) to silently never render on some  */
/*        page loads. Root cause: the v1.2 guard set                     */
/*        window.__cwCollectionContentInit = true synchronously on ANY   */
/*        script execution, including the very first one — so if the    */
/*        `readmore-less-wrap` custom element hadn't finished rendering  */
/*        its content into the DOM yet by the time DOMContentLoaded      */
/*        fired (an async/lazy render, timing varies by network/cache),*/
/*        `rte` was null, the enhancer bailed out, and NO further retry */
/*        was possible — the guard had already permanently blocked the  */
/*        second <script> include (our only other chance to run) before */
/*        it could even register its own attempt. This is why the bug   */
/*        was intermittent: fast/cached loads worked, slow/fresh loads  */
/*        silently failed and showed plain unstyled FAQ text.           */
/*        Fix: only mark a given rte element as done AFTER successfully */
/*        processing it (via a per-element dataset flag, not a global   */
/*        one-shot flag). Both script includes now register a retry     */
/*        loop (immediate attempt + MutationObserver + interval         */
/*        fallback up to ~8s) so whichever one runs first keeps trying  */
/*        until the content actually exists, then the per-element flag  */
/*        stops any duplicate processing. Still flagging the duplicate   */
/*        <script> include to Elara — theme.liquid + main-collection    */
/*        both load this file; one should be removed — but it's no      */
/*        longer harmful now that idempotency is per-element.            */
/* v1.2 — Added idempotency guard (superseded by v1.3, see above).       */
/* v1.1 — Fixed: (1) rte selector now matches BOTH description_position  */
/*        "before" (.hdt-rte div exists) AND "after" (no .hdt-rte, just  */
/*        .hdt-collection-description directly) layouts. (2) Sections   */
/*        6/7/8 were previously OUTSIDE the ready() callback, causing a */
/*        ReferenceError on `rte` that silently killed Quick Tips, Steps*/
/*        and Safety box rendering on every page. Moved inside.         */

(function() {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function findRte() {
    // Match .hdt-rte if present (description_position: "before"),
    // otherwise fall back to .hdt-collection-description directly
    // (description_position: "after" — no .hdt-rte wrapper in that layout),
    // otherwise fall back to .cw-article-body (Elara's blog article template —
    // added v1.4, see changelog).
    return document.querySelector('.hdt-collection-description .hdt-rte') ||
           document.querySelector('.readmore-less-wrap .hdt-rte') ||
           document.querySelector('.hdt-collection-description') ||
           document.querySelector('readmore-less-wrap.hdt-collection-description') ||
           document.querySelector('.cw-article-body');
  }

  function enhance(rte) {
    // Per-element idempotency: skip if this exact rte was already processed
    // (handles the duplicate <script> include + any repeat observer/interval firings).
    if (rte.dataset.cwEnhanced === '1') return;
    rte.dataset.cwEnhanced = '1';

    var accordion = null;
    var faqHeading = null;

    // --- 1. FAQ ACCORDION ---
    // Find the "Frequently Asked Questions" heading
    var headings = rte.querySelectorAll('h2, h3');
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].textContent.toLowerCase().indexOf('frequently asked') !== -1) {
        faqHeading = headings[i];
        break;
      }
    }

    if (faqHeading) {
      accordion = document.createElement('div');
      accordion.className = 'cw-accordion';

      var nextEl = faqHeading.nextElementSibling;
      var faqPairs = [];

      // Collect h3+p pairs
      while (nextEl) {
        if (nextEl.tagName === 'H2') break;
        if (nextEl.tagName === 'H3') {
          var answerEl = nextEl.nextElementSibling;
          if (answerEl && answerEl.tagName === 'P') {
            faqPairs.push({ q: nextEl, a: answerEl });
            nextEl = answerEl.nextElementSibling;
            continue;
          }
        }
        // Skip the script tag (JSON-LD)
        if (nextEl.tagName === 'SCRIPT') {
          nextEl = nextEl.nextElementSibling;
          continue;
        }
        nextEl = nextEl.nextElementSibling;
      }

      // Build accordion items
      faqPairs.forEach(function(pair) {
        var item = document.createElement('div');
        item.className = 'cw-accordion-item';

        var trigger = document.createElement('button');
        trigger.className = 'cw-accordion-trigger';
        trigger.innerHTML = pair.q.innerHTML;

        var content = document.createElement('div');
        content.className = 'cw-accordion-content';

        var inner = document.createElement('div');
        inner.className = 'cw-accordion-content-inner';
        inner.innerHTML = pair.a.innerHTML;

        content.appendChild(inner);

        trigger.addEventListener('click', function() {
          var isOpen = item.classList.contains('open');
          // Close all
          accordion.querySelectorAll('.cw-accordion-item').forEach(function(el) {
            el.classList.remove('open');
            el.querySelector('.cw-accordion-content').style.maxHeight = '0';
          });
          // Open this one if it was closed
          if (!isOpen) {
            item.classList.add('open');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });

        item.appendChild(trigger);
        item.appendChild(content);

        // Remove original elements
        pair.q.remove();
        pair.a.remove();

        accordion.appendChild(item);
      });

      // Insert accordion after the FAQ heading
      faqHeading.parentNode.insertBefore(accordion, faqHeading.nextSibling);
    }

    // --- 2. COMPARISON TABLE Yes/No ICONS ---
    rte.querySelectorAll('.cw-comparison-table .cw-comp-row').forEach(function(row) {
      if (row.classList.contains('cw-comp-header')) return;
      row.querySelectorAll('div').forEach(function(cell) {
        var text = cell.textContent.trim();
        if (text === 'Yes' || text.indexOf('Yes \u2014') === 0 || text.indexOf('Yes,') === 0) {
          cell.innerHTML = '<span style="color:#1a6b3c;font-weight:600;">\u2714 ' + text + '</span>';
        } else if (text === 'No' || text.indexOf('No \u2014') === 0 || text.indexOf('No,') === 0 || text.indexOf('No ') === 0) {
          cell.innerHTML = '<span style="color:#999;font-weight:500;">\u2716 ' + text + '</span>';
        }
      });
    });

    // --- 3. WRAP "COMPLETE THE LOOK" LINKS ---
    var completeHeading = null;
    rte.querySelectorAll('h2').forEach(function(h) {
      if (h.textContent.toLowerCase().indexOf('complete the look') !== -1) {
        completeHeading = h;
      }
    });

    if (completeHeading) {
      var ul = completeHeading.nextElementSibling;
      if (ul && ul.tagName === 'UL') {
        var wrapper = document.createElement('div');
        wrapper.className = 'cw-complete-look';
        // Convert li > a to standalone links
        ul.querySelectorAll('li > a, li a').forEach(function(link) {
          var clone = link.cloneNode(true);
          // Clean up text (remove the dash separator text)
          clone.textContent = clone.textContent.replace(/\s*\u2014.*$/, '').trim();
          if (!clone.textContent) {
            clone.textContent = link.textContent.replace(/\s*\u2014.*$/, '').trim();
          }
          wrapper.appendChild(clone);
        });
        ul.parentNode.replaceChild(wrapper, ul);
      }
    }

    // --- 4. WRAP "RELATED GUIDES" LIST ---
    var guidesHeading = null;
    rte.querySelectorAll('h2').forEach(function(h) {
      if (h.textContent.toLowerCase().indexOf('related guides') !== -1) {
        guidesHeading = h;
      }
    });

    if (guidesHeading) {
      var guidesUl = guidesHeading.nextElementSibling;
      if (guidesUl && guidesUl.tagName === 'UL') {
        guidesUl.className = 'cw-related-guides';
      }
    }

    // --- 5. WRAP FAQ SECTION ---
    if (faqHeading) {
      var faqWrap = document.createElement('div');
      faqWrap.className = 'cw-faq-section';
      faqHeading.parentNode.insertBefore(faqWrap, faqHeading);
      faqWrap.appendChild(faqHeading);
      if (accordion) faqWrap.appendChild(accordion);
    }

    // --- 6. QUICK TIPS BOX ---
    // Detect h2/h3 containing "Quick Tips" and wrap the following ul in a styled box
    rte.querySelectorAll('h2, h3').forEach(function(heading) {
      var text = heading.textContent.toLowerCase();
      if (text.indexOf('quick tips') !== -1) {
        var nextEl = heading.nextElementSibling;
        if (nextEl && nextEl.tagName === 'UL') {
          var box = document.createElement('div');
          box.className = 'cw-quick-tips';
          var title = document.createElement('div');
          title.className = 'cw-quick-tips-title';
          title.textContent = heading.textContent;
          box.appendChild(title);
          box.appendChild(nextEl.cloneNode(true));
          nextEl.parentNode.replaceChild(box, nextEl);
          heading.style.display = 'none';
        }
      }
    });

    // --- 7. STEPS BOX ---
    // Detect h2/h3 containing "Steps" and wrap the following ol in a styled box
    rte.querySelectorAll('h2, h3').forEach(function(heading) {
      var text = heading.textContent.toLowerCase();
      if (text.indexOf('steps') !== -1 || text.indexOf('step-by-step') !== -1) {
        var nextEl = heading.nextElementSibling;
        if (nextEl && nextEl.tagName === 'OL') {
          var box = document.createElement('div');
          box.className = 'cw-steps-box';
          var title = document.createElement('div');
          title.className = 'cw-steps-box-title';
          title.textContent = heading.textContent;
          box.appendChild(title);
          box.appendChild(nextEl.cloneNode(true));
          nextEl.parentNode.replaceChild(box, nextEl);
          heading.style.display = 'none';
        }
      }
    });

    // --- 8. SAFETY / CARE BOX ---
    // Detect h2 containing "Safety" or "Caring" and wrap following content in a content box
    rte.querySelectorAll('h2').forEach(function(heading) {
      var text = heading.textContent.toLowerCase();
      if (text.indexOf('safety') !== -1 || text.indexOf('caring for') !== -1) {
        var nextEl = heading.nextElementSibling;
        var elements = [];
        while (nextEl && nextEl.tagName !== 'H2') {
          if (nextEl.tagName === 'SCRIPT') break;
          elements.push(nextEl);
          nextEl = nextEl.nextElementSibling;
        }
        if (elements.length > 0) {
          var box = document.createElement('div');
          box.className = 'cw-content-box';
          var title = document.createElement('div');
          title.className = 'cw-content-box-title';
          title.textContent = heading.textContent;
          box.appendChild(title);
          elements.forEach(function(el) {
            box.appendChild(el.cloneNode(true));
            el.parentNode.removeChild(el);
          });
          heading.parentNode.insertBefore(box, heading.nextSibling);
          heading.style.display = 'none';
        }
      }
    });
  }

  // --- RETRY LOOP: keep trying to find + enhance the rte until it exists ---
  // Fixes the race against the async-rendering `readmore-less-wrap` custom
  // element. Whichever of the two duplicate <script> includes runs first
  // "wins" and keeps retrying via MutationObserver + interval; the second
  // include's own retry loop becomes a no-op once `enhance()`'s per-element
  // flag is set, so running the loop twice is harmless.
  function tryEnhance() {
    var rte = findRte();
    if (rte && rte.querySelector('h2, h3, p')) {
      enhance(rte);
      return true;
    }
    return false;
  }

  ready(function() {
    if (tryEnhance()) return;

    // Not ready yet — watch the DOM for the async content to appear.
    var observer = new MutationObserver(function() {
      if (tryEnhance()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Defensive fallback in case MutationObserver misses it for any reason
    // (e.g. content replaced via a method that doesn't trigger the observed
    // mutation types). Poll briefly, then give up.
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      if (tryEnhance() || attempts > 40) { // ~8s at 200ms
        clearInterval(interval);
        observer.disconnect();
      }
    }, 200);
  });
})();
